export enum TableColumnKey {
  Operation = 'operation',
  CreationTime = 'creationTime',
  LastModifiedTime = 'lastModifiedTime',
  DistributorAgentId = 'distributorAgentId',
  Currency = 'currency',
  Balance = 'balance',
  FrozenBalance = 'frozenBalance',
}

export interface TableRow {
  id: number;
  [TableColumnKey.DistributorAgentId]: string;
  [TableColumnKey.Currency]: string;
  [TableColumnKey.Balance]: string;
  [TableColumnKey.FrozenBalance]: string;
  [TableColumnKey.CreationTime]: string;
  [TableColumnKey.LastModifiedTime]: string | undefined;

  rawData: any;
}
